import { Button, Form, Input, Space, Switch, message } from "antd";
import BigScreenApi from "../../../../api/BigScreenApi";
import React, { useEffect, useState } from "react";
import { CreateBigScreenWizardWrapper, EditFormLayout, EditFormRow, FormWrapper, OperationWrapper, Title, TitleWrapper } from "./CreateBigScreenWizard.styled";
import StringUtils from "../../../../util/StringUtils";

interface CreateBigScreenWizardProps {
    bigScreenId: string;
    onClose: ()=> void,
    onComplete: ()=> void
}

const CreateBigScreenWizard: React.FC<CreateBigScreenWizardProps> = (props)=> {
    // api
    let bigScreenApi = new BigScreenApi();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [bigScreen, setBigScreen] = useState<any>({
        name: '',
        editorUrl: '',
        remarks: '',
        enabled: true,
    });
    let [submitEnabled, setSubmitEnabled] = useState(false);
    const [form] = Form.useForm();

    // events
    let onNameChange = (e)=> {
        bigScreen.name = e.target.value;
        setBigScreen({...bigScreen});
    };

    let onEditorUrlChange = (e)=> {
        bigScreen.editorUrl = e.target.value;
        setBigScreen({...bigScreen});
    };

    let onRemarksChange = (e)=> {
        bigScreen.remarks = e.target.value;
        setBigScreen({...bigScreen});
    };

    let onEnabledChange = (checked)=> {
        bigScreen.enabled = checked;
        setBigScreen({...bigScreen});
    };

    // methods
    let loadBigScreen = async()=> {
        if (props.bigScreenId) {
            let bigScreen = (await bigScreenApi.get(props.bigScreenId)).data.data;
            setBigScreen(bigScreen);
            form.setFieldsValue(bigScreen);
        }
    };

    let onSubmit = async ()=> {
        if (StringUtils.isEmpty(props.bigScreenId)) {
            await bigScreenApi.create(bigScreen);
        } else {
            await bigScreenApi.update(bigScreen);
        }
        messageApi.success('保存成功！');
        props.onComplete();
    };

    let onCancel = ()=> {
        props.onClose();
    };

    let validateForm = ()=> {
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            setSubmitEnabled(false);
        });
    }

    // onload
    useEffect(()=> {
        loadBigScreen();
    }, []);

    useEffect(()=> {
        validateForm();
    }, [bigScreen]);

    // render
    return <CreateBigScreenWizardWrapper>
        <TitleWrapper>
            <Title>{ props.bigScreenId ? '编辑大屏信息' : '新建大屏' }</Title>
            {contextHolder}
        </TitleWrapper>

        <FormWrapper>
            <Form form={form} name="big-screen" layout="vertical">
                <EditFormLayout>
                    <EditFormRow>
                        <Form.Item name="name" label="大屏名称" rules={[{required: true, message: '请输入大屏名称'}]}>
                            <Input
                                placeholder="请输入大屏名称"
                                value={bigScreen.name}
                                onChange={onNameChange}
                            />
                        </Form.Item>

                        <Form.Item name="enabled" label="启用">
                            <Switch checked={bigScreen.enabled} onChange={onEnabledChange} />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="editorUrl" label="编辑器地址" rules={[{required: true, message: '请输入编辑器地址'}, {type: 'url', message: '请输入合法的URL地址'}]}>
                            <Input
                                placeholder="请输入编辑器地址，例如 https://editor.example.com/edit"
                                value={bigScreen.editorUrl}
                                onChange={onEditorUrlChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="remarks" label="备注" rules={[{required: false}]}>
                            <Input.TextArea style={{height: '80px'}} onChange={onRemarksChange} placeholder="请输入备注"/>
                        </Form.Item>
                    </EditFormRow>
                </EditFormLayout>
            </Form>
        </FormWrapper>

        <OperationWrapper>
            <Space size="middle">
                <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                <Button type="primary" danger onClick={onCancel}>取消</Button>
            </Space>
        </OperationWrapper>
    </CreateBigScreenWizardWrapper>
};

export default CreateBigScreenWizard;
